import { useState } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '../api/auth.js';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);

  async function onSubmit(e) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const data = await authApi.forgotPassword(email);
      setInfo(
        data?.resetToken
          ? `Dev mode: use this token on the reset page → ${data.resetToken}`
          : 'If that email exists, a reset link has been sent.'
      );
    } catch (err) {
      setError(err.response?.data?.message || 'Could not request reset');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="centered-screen">
      <form className="card auth-form" onSubmit={onSubmit}>
        <h1>Reset your password</h1>
        <p className="muted">We'll send a reset link if an account exists for this email.</p>

        <label>
          Email
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </label>

        {info && <div className="alert info">{info}</div>}
        {error && <div className="alert error" role="alert">{error}</div>}

        <button type="submit" className="btn primary" disabled={submitting}>
          {submitting ? 'Sending…' : 'Send reset link'}
        </button>

        <div className="auth-links">
          <Link to="/login">Back to sign in</Link>
        </div>
      </form>
    </div>
  );
}
